<div class="{{localService.selectedLanguageCode}}" *ngIf="localService.languageContent != null && localService.languageContent.location_popup != undefined">
  <app-popup-header title="{{localService.languageContent.location_popup.header}}"></app-popup-header>
  <div class="modal-body" *ngIf="wrapper != undefined" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
    <app-language-container [MaxLength]="100" [(languageContents)]="wrapper.languageContents" (onEmptyLanguageContainerAdded)="onEmptyLanguageContainerAdded($event)" [IsShowAllLanguages]="true" [IsAllMandatory]="true"  [isModeChangeAllowed]="false"></app-language-container>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="onPopupSave()">{{localService.languageContent.common.save}}</button>
  </div>
</div>
